module.exports = __webpack_public_path__ + "img/disconnected 1.75f8764f.svg";